
import { useState, useEffect } from 'react';

export const useUserSearch = () => {
  const [inputValue, setInputValue] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(inputValue);
    }, 500);

    return () => clearTimeout(timer);
  }, [inputValue]);

  return {
    inputValue,
    setInputValue,
    searchTerm: debouncedSearchTerm
  };
};
